import { createSelector } from "reselect";
import { IRegistrationInitialState } from "./types";


export const stateSelector = (state: any): IRegistrationInitialState => state.registrationReducer;
export const isAutoRegisterSuccessSelector = createSelector(stateSelector, (state) => state.isAutoRegisterSuccess);